export default class Hubspot {
  static inject() {
    const hubSpotIFrame = $('iframe.hs-form-iframe')
      .eq(0)
      .contents();
    hubSpotIFrame.find('#custom-form-css').remove();

    const link = document.createElement('link');
    link.type = 'text/css';
    link.rel = 'stylesheet';
    link.href = `${MAIN_URL}css/hubspot-style.css`;
    hubSpotIFrame.find('head').append(link);

    link.onload = function() {
      $('.preloader-container').removeClass('show');
    };
  }
}
